declare type Currency = { getCode: string };

declare module '~types' {
  interface Currency {
    getCode: string;
  }
}

export const Currency = {
  getCode: {
    read(_root: any, { readField }) {
      const code = readField('code');

      return `&#${code};`;
    },
  },
};
